import { useTranslations } from '@/i18n/client';
import { OrdersApi } from '@/services/api/orders-api';

import { OrderReviewPage } from './OrderReviewPage';
import type { OrderReviewWorkflow } from './order-review-types';
import { isDesignReviewState } from './order-status';

export function DesignReviewPage() {
  const t = useTranslations('common.designReview');
  const workflow: OrderReviewWorkflow = {
    modelFilePolicy: 'configured-models',
    copy: {
      page: {
        title: t('title'),
        eyebrow: t('eyebrow'),
        description: t('description'),
        loading: t('loading'),
        notAvailable: t('notAvailable'),
        backToOrder: t('backToOrder'),
        backToOrders: t('backToOrders'),
      },
      viewer: {
        title: t('viewer.title'),
        placeholder: t('viewer.placeholder'),
        description: t('viewer.description'),
      },
      files: {
        eyebrow: t('files.eyebrow'),
        title: t('files.title'),
        description: t('files.description'),
        noFiles: t('files.noFiles'),
        reviewHint: t('files.reviewHint'),
      },
      decision: {
        eyebrow: t('decision.eyebrow'),
        title: t('decision.title'),
        description: t('decision.description'),
        accept: t('decision.accept'),
        accepting: t('decision.accepting'),
        reject: t('decision.reject'),
        rejecting: t('decision.rejecting'),
      },
      success: {
        dialogTitle: t('success.dialogTitle'),
        accepted: t('success.accepted'),
        rejected: t('success.rejected'),
        backToOrder: t('success.backToOrder'),
      },
      rejection: {
        eyebrow: t('rejection.eyebrow'),
        title: t('rejection.title'),
        description: t('rejection.description'),
        reasonLabel: t('rejection.reasonLabel'),
        reasonPlaceholder: t('rejection.reasonPlaceholder'),
        reasonRequired: t('rejection.reasonRequired'),
        close: t('rejection.close'),
        cancel: t('rejection.cancel'),
        submit: t('rejection.submit'),
        submitting: t('rejection.submitting'),
      },
    },
    isPageStateValid: isDesignReviewState,
    isReviewRequired: isDesignReviewState,
    submitDecision: (client, request) => new OrdersApi(client).reviewDesign(request),
  };

  return <OrderReviewPage workflow={workflow} />;
}
